import { createSlice } from "@reduxjs/toolkit";

const arrayDataCheckBoks = createSlice({
  name: "arrayDataCheckBoks",
  initialState: {
    arrayDataCheckBoks: {},
  },
  reducers: {
    SetArrayDataCheckBoks: (state, action) => {
      if (action.payload == undefined) {
        state.arrayDataCheckBoks = {};
      } else {
        state.arrayDataCheckBoks[action.payload.KeyName] = action.payload.array;
      }
    },
    DeleteItemFromArrayDataCheckBoks: (state, action) => {
      const { KeyName, id, keyIdName } = action.payload;

      const currentArray = state.arrayDataCheckBoks[KeyName] || [];

      const updatedArray = currentArray.filter(
        (item) => String(item[keyIdName]) !== String(id)
      );

      state.arrayDataCheckBoks[KeyName] = updatedArray;

      localStorage.setItem(KeyName, JSON.stringify(updatedArray));
    },
  },
});

export const { SetArrayDataCheckBoks, DeleteItemFromArrayDataCheckBoks } =
  arrayDataCheckBoks.actions;
export default arrayDataCheckBoks.reducer;
